import {
  keepPreviousData,
  queryOptions,
  useQuery,
} from '@tanstack/react-query';

import { RequestBodyParams } from '@/shared/config';

import { adaptProductCatalog } from './adapters';
import { getProductCatalogData } from '../api/productCatalogApi';
import { getProductOneData } from '../api/productOneApi';

export const productPageQueryKeys = {
  all: ['product-one'] as const,
  catalog: (slug: string, params?: RequestBodyParams) =>
    [...productPageQueryKeys.all, 'catalog', slug, params] as const,
  page: (slug?: string) => [...productPageQueryKeys.all, 'page', slug] as const,
};

export const useProductOneData = (params: { slug: string }) => {
  return useQuery({
    queryKey: productPageQueryKeys.page(params.slug),
    queryFn: () => getProductOneData(params),
  });
};

export const catalogQueryOptions = (slug: string, params: RequestBodyParams) =>
  queryOptions({
    queryKey: productPageQueryKeys.catalog(slug, params),
    queryFn: async () =>
      adaptProductCatalog(await getProductCatalogData(slug, params)),
  });

export const useProductCatalogData = (
  slug: string,
  params: RequestBodyParams,
  options?: { enabled?: boolean },
) =>
  useQuery({
    ...catalogQueryOptions(slug, params),
    enabled: options?.enabled ?? true,
    placeholderData: keepPreviousData,
  });
